import { render, staticRenderFns } from "./returns-policy.vue?vue&type=template&id=792ff2aa"
import script from "./returns-policy.vue?vue&type=script&lang=js"
export * from "./returns-policy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports